import React, { useEffect, useState } from "react";
import { Collapse, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { MenuOutlined, ArrowRightOutlined } from "@ant-design/icons";

import logo from "../../assets/landingFeatures/qhrFlow.png";
import hiring from "../../assets/landingFeatures/hiring1.jpg";
import workflow from "../../assets/landingFeatures/workflow.jpg";
import profileIcon from "../../assets/profile.png";

import LandingHeader from "../header";
import Footer from "../footer";

import "./qhrflowlanding.scss";

function QHRFlowLanding() {
  const [hamburgerMenuOpen, setHamburgerMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /* =========================
     DATA
  ========================= */

  const featureItems = [
    {
      key: "1",
      label: "AI Recruitment Workflow",
      children: (
        <p>
          Automate hiring pipelines, approvals, and candidate movement with
          intelligent workflows.
        </p>
      ),
    },
    {
      key: "2",
      label: "Application Tracking",
      children: (
        <p>
          Track every candidate stage in real-time with complete visibility.
        </p>
      ),
    },
    {
      key: "3",
      label: "Vendor Management",
      children: (
        <p>
          Manage recruitment vendors and monitor submissions from a single
          dashboard.
        </p>
      ),
    },
    {
      key: "4",
      label: "Recruiter Productivity",
      children: (
        <p>
          Reduce manual work and focus only on quality candidate hiring.
        </p>
      ),
    },
  ];

  const benefitItems = [
    {
      key: "1",
      label: "For Organizations",
      children: (
        <p>
          Reduce hiring cost, improve recruitment efficiency, and increase
          workforce productivity.
        </p>
      ),
    },
    {
      key: "2",
      label: "For HR Managers",
      children: (
        <p>
          Manage teams, monitor performance, and streamline hiring operations.
        </p>
      ),
    },
    {
      key: "3",
      label: "For Recruiters",
      children: (
        <p>
          Simplified sourcing workflow with better resume filtering and
          candidate tracking.
        </p>
      ),
    },
    {
      key: "4",
      label: "For Candidates",
      children: (
        <p>
          Transparent application tracking and interview process visibility.
        </p>
      ),
    },
    {
      key: "5",
      label: "For Vendors",
      children: (
        <p>
          Easy-to-use vendor portal with submission tracking and reporting.
        </p>
      ),
    },
  ];

  const trustedCompanies = [
    "HMWComm",
    "TechNova",
    "PeopleGrid",
    "HireStack",
    "QubitHR",
  ];

  const stats = [
    {
      value: "40%",
      label: "Reduction In Hiring Time",
    },
    {
      value: "10K+",
      label: "Candidates Processed",
    },
    {
      value: "20+",
      label: "Recruiters Using QHRFLOW",
    },
    {
      value: "99%",
      label: "Workflow Visibility",
    },
  ];

  /* =========================
     NAVIGATION
  ========================= */
  const handleSignin = () => {
    navigate("/otpprocess/qhrflow", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    });

    setHamburgerMenuOpen(false);
  };

  const handleSignup = () => {
    navigate("/signup/qhrflow");
    setHamburgerMenuOpen(false);
  };

  const handleContact = () => {
    navigate("/qhrflowcontact");
  };

  const handleMobileNavigation = (path) => {
    navigate(path);
    setHamburgerMenuOpen(false);
  };

  /* =========================
     RENDER
  ========================= */

  return (
    <div className="qhrflowlanding-wrapper">

      {/* =========================
          TOP HEADER
      ========================= */}

        <LandingHeader />

      {/* =========================
          MAIN HEADER
      ========================= */}

      <header className="qhrflowlanding-header">

        <div className="qhrflowlanding-header-left">
          <Link to="/qhrflow" className="qhrflowlanding-logo">
            <img
              className="qhrflowlanding-logo-img"
              src={logo}
              alt="QHRFLOW"
            />
          </Link>
        </div>

        <div className="qhrflowlanding-header-right">

          <nav className="qhrflowlanding-menu">
            <Link to="/qhrflow">Features</Link>

            <Link to="/qhrflowvendorconnect">
              VendorConnect
            </Link>
          </nav>

          <div className="qhrflowlanding-sign">

            <Button
              className="qhrflowlanding-sign-button"
              onClick={handleSignin}
            >
              Sign In
            </Button>

            <Button
              type="primary"
              className="qhrflowlanding-sign-button"
              onClick={handleSignup}
            >
              Get Started
            </Button>

          </div>
        </div>

        <button
          type="button"
          className="qhrflowlanding-hamburger-menu"
          onClick={() =>
            setHamburgerMenuOpen(!hamburgerMenuOpen)
          }
          aria-label="Open menu"
        >
          <MenuOutlined />
        </button>

      </header>

      {/* =========================
          MOBILE MENU
      ========================= */}

      <div
        className={`qhrflowlanding-header-responsive ${
          hamburgerMenuOpen ? "open" : ""
        }`}
      >

        <div
          className="qhrflowlanding-header-responsive-item"
          onClick={() =>
            handleMobileNavigation("/qhrflow")
          }
        >
          Features
        </div>

        <hr />

        <div
          className="qhrflowlanding-header-responsive-item"
          onClick={() =>
            handleMobileNavigation("/qhrflowvendorconnect")
          }
        >
          VendorConnect
        </div>

        <hr />

        <div
          className="qhrflowlanding-header-responsive-item"
          onClick={handleSignup}
        >
          Get Started
        </div>

        <hr />

        <div
          className="qhrflowlanding-header-responsive-item"
          onClick={handleSignin}
        >
          Sign In
        </div>

      </div>

      {/* =========================
          HERO
      ========================= */}

      <section className="qhrflowlanding-main">

        <div className="qhrflowlanding-main-slider">

          <div className="qhrflowlanding-main-text-wrapper">

            <h1 className="qhrflowlanding-main-text">
              Hire Faster With AI-Powered Recruitment Workflow
            </h1>

            <p className="qhrflowlanding-main-subtext">
              Manage recruiters, vendors, candidates, interviews, and
              analytics from one intelligent hiring platform.
            </p>

            <div className="qhrflowlanding-register-button">

              <Button
                type="primary"
                size="large"
                onClick={handleSignup}
              >
                Start Free Trial
              </Button>

              <Button
                size="large"
                onClick={handleContact}
              >
                Book Demo
              </Button>

            </div>

          </div>

          <div className="punch-heading-wrapper">
            <img
              src={workflow}
              alt="QHRFLOW recruitment workflow"
            />
          </div>

        </div>

      </section>

      {/* =========================
          TRUSTED BY
      ========================= */}
      {/* Trusted By */}
      <div className="qhrflowlanding-trusted-section">
        <div className="qhrflowlanding-trusted-heading">
          Trusted By
        </div>

        <div className="qhrflowlanding-trusted-wrapper">
                {trustedCompanies.map((company) => (
                  <div
                    className="qhrflowlanding-trusted-card"
                    key={company}
                  >
                    {company}
                  </div>
                ))}
        </div>
      </div>


      {/* =========================
          FEATURES
      ========================= */}

      <section className="landing-features features-wrapper">

        <h2 className="feature-heading">
          Tools For Modern Hiring
        </h2>

        <div className="qhrflowlanding-features">

          <div className="features-left">
            <Collapse
              accordion
              items={featureItems}
              defaultActiveKey={["1"]}
            />
          </div>

          <div className="qhrflowfeatures-right">
            <img
              src={hiring}
              alt="QHRFLOW hiring dashboard"
              className="features-right-dashboard"
            />
          </div>

        </div>

      </section>
      {/* =========================
          STATS
      ========================= */}

      <section className="landing-features">

        <div className="qhrflowlanding-stats-wrapper">

          {stats.map((item) => (
            <div
              className="qhrflowlanding-stat-card"
              key={item.label}
            >
              <h2>{item.value}</h2>
              <p>{item.label}</p>
            </div>
          ))}

        </div>

      </section>
      {/* =========================
          BENEFITS
      ========================= */}

      <section className="landing-features features-wrapper">

        <h2 className="feature-heading-secondary">
          Built For Every Hiring Stakeholder
        </h2>

        <div className="qhrflowlanding-features">

          <div className="features-left">

            <Collapse
              accordion
              items={benefitItems}
              defaultActiveKey={["1"]}
            />

          </div>

          <div className="qhrflowfeatures-right">

            <div className="features-right-image">
              <img
                src={profileIcon}
                alt="Recruiter"
              />
            </div>

            <div className="features-right-text">
              “QHRFLOW reduced our hiring time by 40% and helped
              recruiters focus only on qualified candidates.”
            </div>

            <div className="features-right-text-designation">
              Akansha Dube
            </div>

            <div className="features-right-text-company">
              Lead Recruiter • HMWComm
            </div>

          </div>

        </div>

      </section>



      {/* =========================
          CTA
      ========================= */}

      <section className="feature-end-wrapper">

        <div className="feature-img2-wrapper">

          <div className="feature-card">
            Start Hiring Smarter Today
          </div>

        </div>

        <div className="feature-endHeading-wrapper">

          <div className="feature-endHeading">

            Experience the{" "}

            <span className="feature-endHeading-light">
              difference
            </span>

            <br />

            Try{" "}

            <span className="feature-endHeading-bold">
              QuallyHire AI Product Suites
            </span>

          </div>

          <div className="feature-Button-wrapper">

            <Button
              type="primary"
              shape="round"
              size="large"
              onClick={handleContact}
            >
              Talk To Sales
              <ArrowRightOutlined />
            </Button>

          </div>

        </div>

      </section>

      {/* =========================
          FOOTER
      ========================= */}

      <footer className="landing-footer">
        <Footer />
      </footer>

    </div>
  );
}

export default QHRFlowLanding;